import { DateRange } from 'react-day-picker'

export enum DatePickerMode {
  Single = 'single',
  Range = 'range',
}

export type PresetKey = 'today' | 'lastWeek' | 'lastMonth'

export interface DatePickerProps {
  value?: Date | DateRange
  onChange: (date: Date | DateRange | undefined) => void
  placeholder?: string
  className?: string
  hasError?: boolean
  disabled?: boolean
  mode?: DatePickerMode
}

export interface PresetRange {
  from: Date
  to: Date
}

export type PresetRangesMap = Record<PresetKey, PresetRange>
